import React from "react";
import styles from './EvaluationRequestCard.module.scss';
import ProfilePicture from "../profilePicture/ProfilePicture";
import PropTypes from "prop-types";
import Button from "../button/Button";
import EvaluationStatus from "../evaluationStatus/EvaluationStatus";
import LoadingSpinner from "../loadingSpinner/LoadingSpinner";

const EvaluationRequestCard = ({
  profilePicture,
  firstName,
  lastName,
  date,
  status,
  onActionClick,
  isLoading,
}) => {
  return (
    <div className={styles.card}>
      <ProfilePicture
        profilePicture={profilePicture}
        firstName={firstName}
        lastName={lastName}
      />
      {<div className={styles.data}>
        <h4>{firstName} {lastName}</h4>
        <span>Requested&nbsp;Date:&nbsp;{date}</span>
      </div>}
      <div className={styles.actions}>
        {isLoading ? 
          <LoadingSpinner size={20} />
        : status === 'Pending' ? <>
          <Button
            label="Decline"
            size="small"
            variant="secondary"
            onClick={(e) => {
              e.stopPropagation()
              onActionClick('Declined');
            }}
          />
          <Button
            label="Accept"
            size="small"
            onClick={(e) => {
              e.stopPropagation()
              onActionClick('Accepted');
            }}
          />
        </> : <EvaluationStatus status={status} />}
      </div>
    </div>
  );
};

EvaluationRequestCard.propTypes = {
  profilePicture: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['Pending', 'Accepted', 'Declined']).isRequired,
  onActionClick: PropTypes.func,
  isLoading: PropTypes.bool
}

export default EvaluationRequestCard;